import {Category, Option, Subcategory} from "./types";

export const categoryToOption = (category: Category | Subcategory): Option => ({
    label: category.localizedName,
    value: category.id,
    documentId: category.documentId
})